import React from "react";
import { Tooltip } from "react-tooltip";
import { t } from "ttag";

import { IFormUUID, ProductUUID } from "../../../models/nominals";
import {
    IReviewsProduct,
    IReviewsProductVariantChoices,
} from "../../../models/reviews";
import { useAppDispatch, useAppSelector } from "../../../store/reducers";
import {
    NOT_SURE_VARIANT_CHOICE_SLUG,
    WriteReviewFormMode,
} from "../constants";
import { defaultState } from "../defaults";
import { IWriteReviewFormState } from "../models";
import { setWriteReviewFormMode } from "../reducers";
import {
    getProductByUUID,
    getWriteReviewFormSelectedVariant,
    getWriteReviewFormState,
} from "../selectors";

const getIsSelected = (formState: IWriteReviewFormState | null): boolean => {
    return formState?.mode !== WriteReviewFormMode.CLOSED;
};

export const MultiProductWriteReviewFormProductHeading = (props: {
    productUUID: ProductUUID;
    formUUID: IFormUUID;
    side?: string;
}): React.ReactNode => {
    const [isTooltipOpen, setIsTooltipOpen] = React.useState(false);
    const tipId = React.useId();

    const state = useAppSelector(
        (rootState) => rootState.reviews || defaultState,
    );
    const dispatch = useAppDispatch();

    const product: IReviewsProduct | null = getProductByUUID(state, props);
    const formState: IWriteReviewFormState | null = getWriteReviewFormState(
        state,
        props,
    );
    const selectedVariant: IReviewsProductVariantChoices =
        getWriteReviewFormSelectedVariant(state, props);

    const isSelected = getIsSelected(formState);

    const onCheckboxChange = () => {
        const newMode = isSelected
            ? WriteReviewFormMode.CLOSED
            : WriteReviewFormMode.FORM_OPEN;
        dispatch(
            setWriteReviewFormMode({
                formUUID: props.formUUID,
                mode: newMode,
            }),
        );
    };

    if (!product || !formState) {
        return null;
    }

    if (formState?.mode === WriteReviewFormMode.THANK_YOU_OPEN) {
        return (
            <div key={`${product.uuid}`}>
                <label className="wrf-rating__title">
                    <input
                        type="checkbox"
                        name="multi-product-write-review-form-selected-products"
                        value={`${product.uuid}`}
                        disabled={true}
                        checked={isSelected}
                    />
                    {product.name}
                    {selectedVariant &&
                    selectedVariant !== NOT_SURE_VARIANT_CHOICE_SLUG
                        ? `: ${selectedVariant.display_name}`
                        : ""}
                </label>
            </div>
        );
    }

    return (
        <div key={`${product.uuid}`}>
            <label className="wrf-rating__title">
                <input
                    type="checkbox"
                    name="multi-product-write-review-form-selected-products"
                    value={`${product.uuid}`}
                    checked={isSelected}
                    onChange={onCheckboxChange}
                />
                {product.name}
                {props.side && ` Split King - Side ${props.side}`}
                {selectedVariant &&
                selectedVariant !== NOT_SURE_VARIANT_CHOICE_SLUG
                    ? `: ${selectedVariant.display_name}`
                    : ""}
            </label>
            {props.side && (
                <div>
                    <a
                        aria-expanded={isTooltipOpen}
                        className="multi-product-review__header-cart-ref-icon-container"
                        data-tooltip-id={tipId}
                        title={t`What does Side One and Side Two mean?`}
                    >
                        {t`What does Side One and Side Two mean`}
                    </a>
                    <Tooltip
                        afterHide={() => setIsTooltipOpen(false)}
                        afterShow={() => setIsTooltipOpen(true)}
                        id={tipId}
                        className="tooltip"
                        delayHide={200}
                        openEvents={{ click: true }}
                        globalCloseEvents={{ escape: true, scroll: true }}
                    >
                        {t`You purchased a Split King Mattress with two different mattress feels.`}
                        <br />
                        {t`Please review each side of the mattress individually.`}
                    </Tooltip>
                </div>
            )}
        </div>
    );
};
